/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { eTicketDesignPreviewViewViewModel } from 'app/modules/design/e-ticket-design/e-ticket-design-detail/models/e-ticket-design-preview-view-view.model';
import { eTicketDesignPreviewViewModel } from 'app/modules/design/e-ticket-design/e-ticket-design-detail/models/e-ticket-design-preview-view.model';
import { eTicketDesignDetailService } from 'app/modules/design/e-ticket-design/e-ticket-design-detail/services/e-ticket-design-detail.service';
import { ETicketBackgroundOption } from '../../e-ticket-design-management/models/e-ticket-background-option';
import { ETicketLayoutStyle } from '../../e-ticket-design-management/models/e-ticket-layout-style';

@Component({
	selector: 'e-ticket-design-preview-view',
	templateUrl: './e-ticket-design-preview-view.component.html',
	styleUrls: ['./e-ticket-design-preview-view.component.scss'],
	standalone: false,
})
export class eTicketDesignPreviewViewComponent implements OnInit {
	@Input() designId: number;
	@Input() eventId: number;
	@Input() currentLayoutStyle: ETicketLayoutStyle;
	@Input() currentText: string;
	@Input() currentImage: string;
	@Input() fadeImage: boolean = false;
	@Input() backgroundOption: ETicketBackgroundOption;
	viewModel: eTicketDesignPreviewViewViewModel;
	constructor(private route: ActivatedRoute, private service: eTicketDesignDetailService, private sanitizer: DomSanitizer) {}

	ngOnInit() {
		this.loadViewModel();
	}

	loadViewModel() {
		this.service.getETicketDesignPreviewView(this.designId, this.eventId).then((response: eTicketDesignPreviewViewModel) => {
			this.viewModel = new eTicketDesignPreviewViewViewModel(response);
			this.viewModel.itemId = response.id;
		});
	}

	public reload() {
		this.loadViewModel();
	}

	doIconButtonAction(action) {
		switch (action) {
			default: {
				console.log('Unsupported action: ' + action);
				break;
			}
		}
	}

	get shouldFadeImage(): string {
		return this.fadeImage ?? this.viewModel?.dataModel?.fadeImage;
	}

	get eventImage(): string {
		var image = this.viewModel?.dataModel?.eventImage === null || this.viewModel?.dataModel?.eventImage === '' ? 'https://picsum.photos/seed/event/512/512' : this.viewModel?.dataModel?.eventImage;
		if (image && !image.startsWith('http') && !image.startsWith('data:image')) {
			// Assume it's a base64 JPEG string
			return `data:image/png;base64,${image}`;
		}
		return image;
	}

	get displayImage(): string {
		const image = this.currentImage ?? this.viewModel?.dataModel?.eTicketImage;
		if (image && !image.startsWith('http') && !image.startsWith('data:image')) {
			// Assume it's a base64 JPEG string
			return `data:image/png;base64,${image}`;
		}
		return image;
	}

	get isFullWidthImage(): boolean {
		return (this.currentLayoutStyle ?? this.viewModel?.dataModel?.layoutStyle) === ETicketLayoutStyle.FullWidthImage;
	}
	get isImageAndText(): boolean {
		return (this.currentLayoutStyle ?? this.viewModel?.dataModel?.layoutStyle) === ETicketLayoutStyle.ImageAndText;
	}
	get isTextAndImage(): boolean {
		return (this.currentLayoutStyle ?? this.viewModel?.dataModel?.layoutStyle) === ETicketLayoutStyle.TextAndImage;
	}
	get isFullWidthText(): boolean {
		return (this.currentLayoutStyle ?? this.viewModel?.dataModel?.layoutStyle) === ETicketLayoutStyle.FullText;
	}

	get displayText(): SafeHtml {
		return this.sanitizer.bypassSecurityTrustHtml(this.currentText ?? this.viewModel?.dataModel?.eTicketText);
	}

	get backgroundStyle() {
		if (this.backgroundOption === ETicketBackgroundOption.Tiled) {
			var backgroundImage = this.viewModel?.dataModel?.defaultBackgroundImageUrl;
			return {
				'background-image': `url("${backgroundImage}")`,
				'background-repeat': 'repeat',
			};
		}
		return {};
	}
}
